import { render, staticRenderFns } from "./VueSwing.vue?vue&type=template&id=3b624770&"
import script from "./VueSwing.vue?vue&type=script&lang=js&"
export * from "./VueSwing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports